import { CellColors } from '../model/colors.model';

const ficoScoreRiskLevels = {
  veryHighRisk: { from: 100, to: 499 },
  highRisk: { from: 500, to: 559 },
  mediumRisk: { from: 560, to: 709 },
  lowRisk: { from: 710, to: 799 },
  veryLowRisk: { from: 800, to: 850 },
};

enum MentorPlaylistRating {
  notStarted = 3,
  incomplete = 2,
  complete = 1,
  notApplicable = 0,
}

enum MentorPlaylistStatus {
  notStarted = 'notStarted',
  incomplete = 'incomplete',
  complete = 'complete',
  notApplicable = 'na',
}

export const ficoScoreCssClass = (score: number): string => {
  switch (true) {
    case score >= ficoScoreRiskLevels.lowRisk.from && score <= ficoScoreRiskLevels.veryLowRisk.to:
      return CellColors.green;
    case score >= ficoScoreRiskLevels.mediumRisk.from && score <= ficoScoreRiskLevels.mediumRisk.to:
      return CellColors.amber;
    case score >= 1 && score <= ficoScoreRiskLevels.highRisk.to:
      return CellColors.red;
    default:
      return null;
  }
};

export const convertMentorPlaylistRatingToStatus = (rating: MentorPlaylistRating): string => {
  switch (rating) {
    case MentorPlaylistRating.complete:
      return MentorPlaylistStatus.complete;
    case MentorPlaylistRating.incomplete:
      return MentorPlaylistStatus.incomplete;
    case MentorPlaylistRating.notStarted:
      return MentorPlaylistStatus.notStarted;
    case MentorPlaylistRating.notApplicable:
      return MentorPlaylistStatus.notApplicable;
  }
};

export const mentorPlaylistCssClass = (rating: MentorPlaylistRating): string | null => {
  switch (rating) {
    case MentorPlaylistRating.complete:
      return CellColors.green;
    case MentorPlaylistRating.incomplete:
      return CellColors.amber;
    case MentorPlaylistRating.notStarted:
      return CellColors.red;
    case MentorPlaylistRating.notApplicable:
      return null;
  }
};
